<div
  class="middlecards"
  [formGroup]="form()">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">Audit Basics</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <h2>Creation</h2>
      <div class="middlecards">
        <mat-form-field>
          <mat-label>Date</mat-label>
          <input
            matInput
            placeholder="Date"
            [matDatepicker]="picker"
            [value]="audit().createdAt"
            disabled />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field [class.flex-doubleWidth]="showEditableDraft()">
          <mat-label>Creator</mat-label>
          <input
            matInput
            placeholder="Creator"
            [value]="
              (audit().createdByUserId | userName | async) ||
              'NONE' + ' ' + ((audit().createdByUserId | azureIdStatus | async) || '')
            "
            disabled />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Audit Dep</mat-label>
          <input
            matInput
            placeholder="Audit Dep."
            [value]="form().get('auditor')?.value"
            disabled />
        </mat-form-field>
      </div>
      <div>
        <div class="controller-title flex-center">
          <span class="controller-text bold"
            >{{ form().get('createdBy')?.value | userName | async }}
            {{ form().get('newCreatedBy')?.value | azureIdStatus | async }}</span
          >
          <ng-container>
            <button
              mat-button
              (click)="selectPerson('createdBy')">
              <mat-icon
                class="icon-button orangeText"
                style="vertical-align: middle"
                >person_add</mat-icon
              >
            </button>
          </ng-container>
        </div>
        <p class="warning">This field overwrites the Auditor / Creator when set</p>
      </div>
      <h2>Concerns</h2>
      @if (!showEditableDraft()) {
      <mat-form-field class="full-width">
        <input
          matInput
          placeholder="name"
          [value]="form().get('concernsName')?.value || ''" />
      </mat-form-field>
      }
      <div class="middlecards">
        <mat-form-field>
          <input
            id="reportingYear"
            matInput
            formControlName="reportingYear"
            type="number"
            placeholder="Report Year"
            [min]="1970"
            [max]="currentDate.getFullYear()" />
          @if (chkError('reportingYear')) {
          <mat-error> Please enter a valid year </mat-error>
          }
        </mat-form-field>
        @if (!showEditableDraft()) {
        <mat-form-field>
          <input
            matInput
            placeholder="Legal Unit"
            [value]="form().get('legalUnit')?.value" />
        </mat-form-field>
        }
        <mat-form-field>
          <input
            matInput
            placeholder="BG"
            [value]="form().get('department')?.value || 'NONE'" />
        </mat-form-field>
        @if (isGPIA() && showEditableDraft()) {
        <mat-checkbox
          formControlName="isSpecialAudit"
          class="vertically-centered"
          color="primary">
          Special Audit</mat-checkbox
        >
        }
      </div>
      <div>
        @if(plants){
        <mat-form-field>
          <mat-select
            formControlName="plant"
            (selectionChange)="changePlant()"
            placeholder="Select Plant">
            <mat-option [value]="">Nothing selected</mat-option>
            @for (plant of plants; track plant) {
            <mat-option [value]="plant.plantName">{{ plant.plantName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
      </div>
      @if (showEditableDraft()) {
      <h2>Get Company Information</h2>
      <div class="get-company-buttons">
        <p>Choose a company of</p>
        <div>
          <mat-form-field>
            <mat-label>Autoneum</mat-label>
            <mat-select
              (selectionChange)="setCompanyData()"
              formControlName="legalUnit">
              @for (organization of uniqueOrgs(); track organization) {
              <mat-option [value]="organization">{{ organization }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      }
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title class="title">Status Setting</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <h2>Actual Status</h2>
      {{ form().get('status')?.value }}
      @if (showEditableDraft()) {
      <div>
        <h2>Initial Audit Definition</h2>
        <p>
          Define the 'Audit Basics', then go to 'Responsibles', define them and click on 'Basic Definitions are
          complete'
        </p>
      </div>
      } @if (!showEditableDraft()) {
      <div class="change_status">
        <mat-radio-group formControlName="status">
          <mat-radio-button value="Pending">Pending</mat-radio-button>
        </mat-radio-group>
      </div>
      } @if (!showEditableDraft()) {
      <div>
        @if (isStatus('Settled') || isStatus('Finally settled') || isStatus('Adjourned')) {
        <button
          class="status-button"
          (click)="setNewStatus('Pending')"
          mat-raised-button>
          Pending
        </button>
        } @if (isStatus('Pending') || isStatus('Pending & Overdue') || isStatus('Adjourned')) {
        <button
          class="status-button"
          (click)="setNewStatus('Settled')"
          mat-raised-button>
          Settled
        </button>
        } @if (accessService.hasAuditorRole() && (isStatus('Pending') || isStatus('Settled') || isStatus('Pending &
        Overdue') || isStatus('Adjourned'))) {
        <button
          class="status-button"
          (click)="setNewStatus('Finally settled')"
          mat-raised-button>
          Finally settled
        </button>
        }
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
